export default function useCompanyImageBaseUrl() {
    return (import.meta.env.VITE_API_HOST_BASE_URL || '') as string;
}
